module.exports = __webpack_public_path__ + "img/powered.6af37039.svg";